import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const errorMessage = (props) => {
  const { errors, details } = props;
  return (
    <div>
      <ul className="alert alert-danger list-unstyled" role="alert">
        {errors} {details}
      </ul>
    </div>
  );
};

const successMessage = ({ message, details }) => {
  return (
    <React.Fragment>
      <div className="alert alert-success" role="alert">
        <div>
          <div className="text-center" style={{ paddingBottom: "20px" }}>
            <FontAwesomeIcon icon="thumbs-up" size="3x" />
          </div>
          <h4 className="alert-heading text text-center">{message} </h4>
        </div>
        <hr />
        <div>
          <FontAwesomeIcon
            icon="info-circle"
            size="2x"
            style={{ paddingRight: "10px" }}
          />
          <span className="mb-0 text text-center">{details}</span>
        </div>
      </div>
    </React.Fragment>
  );
};

const userHasAccount = (props) => <div> has account</div>;

const unauthorized = (props) => {
  return (
    <React.Fragment>
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <div className="jumbotron jumbotron-fluid bg-danger text-light text-center">
              <div className="container">
                <h2 className="text">Não autorizado</h2>
                <p className="lead"> por favor realize o login novamente.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default { errorMessage, successMessage, userHasAccount, unauthorized };
